import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.css';

const ChangePassword = ({ email }) => {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const validatePassword = (password) => {
    const regex = /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]).{8,}$/;
    return regex.test(password);
  };

  const handleChangePassword = async () => {
    if (!newPassword || !confirmPassword) {
      return setMessage('Please fill in both fields.');
    }

    if (!validatePassword(newPassword)) {
      return setMessage('Password must be at least 8 chars, include uppercase, number & special character.');
    }

    if (newPassword !== confirmPassword) {
      return setMessage('Passwords do not match.');
    }

    try {
      const res = await fetch('https://salesjet-10097049716.development.catalystappsail.com/change-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, newPassword }),
      });

      const data = await res.json();
      if (res.ok) {
        setMessage('✅ Password changed successfully. Redirecting to login...');
        setTimeout(() => navigate('/'), 2000);
      } else {
        setMessage(data.message || 'Failed to update password.');
      }
    } catch (err) {
      setMessage('Something went wrong.');
    }
  };
  
  
  return (
    <>
      <h2 className="login-title">Set New Password</h2>

      <input
        type="password"
        className="login-input"
        placeholder="New password"
        value={newPassword}
        onChange={(e) => setNewPassword(e.target.value)}
      />


      <input
        type="password"
        className="login-input"
        placeholder="Confirm password"
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.target.value)}

      />

      <button className="login-button" onClick={handleChangePassword}>
        Change Password
      </button>

      <p style={{ fontSize: '12px', color: '#555'}}><b>Note :</b></p>
      <p style={{ fontSize: '12px', color: '#555', marginTop: '3px' }}>
        Password must be at least <b>8 characters</b>, contain at least 
        <b> 1 uppercase letter</b>, <b>1 number</b> and <b>1 special character</b>.
      </p>

      {message && <p className="login-message">{message}</p>}

    </>
  );
};

export default ChangePassword;
